const vi = {
  "common.cancel": "Hủy",
  "common.close": "Đóng",
  "common.on": "Bật",
  "common.off": "Tắt",
  "common.show": "Hiện",
  "common.hide": "Ẩn",
  "common.hint": "Gợi ý",
  "common.showHint": "Hiện gợi ý",
  "common.labelCountShowHint": "{label} {count}. Hiện gợi ý",

  "duration.minutes_other": "{count} phút",
  "duration.hours_other": "{count} giờ",

  "splash.description":
    "Aeterna Invicta mong muốn kết hợp những khía cạnh hay nhất và thú vị nhất của Magic the Gathering và Path of Exile thành một trò chơi thẻ bài sưu tầm. Xây dựng bộ bài, khám phá sự kết hợp và sử dụng lá bài thật khéo léo để đánh bại đối thủ.",
  "splash.tagline": "Trở nên bất tử và vô địch!",
  "splash.tutorials": "Người chơi mới? Nhấn vào đây để xem hướng dẫn!",
  "splash.enterGame": "Vào trò chơi",

  "nav.collapse": "Thu gọn thanh điều hướng",
  "nav.expand": "Mở rộng thanh điều hướng",
  "nav.summary": "Tổng kết",
  "nav.game": "Trận đấu",
  "nav.queue": "Tìm trận",
  "nav.decks": "Bộ bài",
  "nav.library": "Thư viện",
  "nav.achievements": "Nhiệm vụ hằng ngày và Thành tựu",
  "nav.customize": "Tùy chỉnh",
  "nav.marketplace": "Chợ",
  "nav.social": "Cộng đồng",
  "nav.ranking": "Xếp hạng",
  "nav.settings": "Cài đặt",
  "nav.workshop": "Xưởng",
  "nav.community": "Diễn đàn",
  "nav.support": "Hỗ trợ",

  "hud.gameLog": "Nhật ký trận",
  "hud.patchNotes": "Ghi chú bản cập nhật",
  "hud.showNavbar": "Hiện thanh điều hướng",
  "hud.hideNavbar": "Ẩn thanh điều hướng",
  "hud.queued": "Đang tìm trận",
  "hud.forfeit": "Đầu hàng",
  "hud.leave": "Rời đi",
  "hud.leaveSpectate": "Ngừng theo dõi",
  "hud.serverMessages": "Thông báo máy chủ",
  "hud.serverMessagesNew": "Thông báo máy chủ (mới)",

  "serverMessages.title": "Thông báo máy chủ",
  "serverMessages.kindAdmin": "Thông báo máy chủ",
  "serverMessages.kindMaintenance": "Bảo trì máy chủ",
  "serverMessages.inProgress":
    "Máy chủ đang bảo trì. Máy chủ có thể khởi động lại bất cứ lúc nào.",
  "serverMessages.beginsIn": "Bảo trì máy chủ bắt đầu sau",
  "serverMessages.empty": "Hiện không có thông báo máy chủ nào.",
  "serverMessages.view": "Xem thông báo máy chủ",
  "serverMessages.template.patchApplied":
    "Bản cập nhật mới đã ra mắt. Hãy tải lại trang hoặc khởi động lại ứng dụng để dùng phiên bản mới nhất.",
  "serverMessages.template.maintenanceComplete":
    "Bảo trì máy chủ đã hoàn tất. Cảm ơn bạn đã kiên nhẫn chờ đợi!",
  "serverMessages.template.restartingNow":
    "Máy chủ đang khởi động lại. Bạn sẽ được kết nối lại tự động trong giây lát.",
  "serverMessages.template.maintenanceExtended":
    "Bảo trì máy chủ kéo dài hơn dự kiến. Chúng tôi sẽ sớm quay lại.",
  "serverMessages.template.investigatingIssue":
    "Chúng tôi đã ghi nhận sự cố và đang điều tra. Cảm ơn bạn đã kiên nhẫn.",
  "serverMessages.template.reportBugs":
    "Cảm ơn bạn đã chơi Aeterna Invicta! Vui lòng báo lỗi qua trang Hỗ trợ.",
  "serverMessages.template.maintenanceCountdown":
    "Bảo trì máy chủ sẽ bắt đầu sau {duration}. Vui lòng hoàn thành trận đấu trước thời điểm đó.",
  "serverMessages.template.maintenanceStarting":
    "Bảo trì máy chủ đang bắt đầu. Máy chủ có thể khởi động lại bất cứ lúc nào.",
  "serverMessages.template.maintenanceCancelled":
    "Lịch bảo trì máy chủ đã bị hủy.",

  "completion.achievement": "Hoàn thành thành tựu",
  "completion.daily": "Hoàn thành nhiệm vụ ngày",

  "settings.title": "Cài đặt",
  "settings.backToMenu": "Quay lại Cài đặt",
  "settings.section.account": "Tài khoản",
  "settings.section.general": "Chung",
  "settings.section.gameplay": "Lối chơi",
  "settings.section.display": "Hiển thị",
  "settings.section.controls": "Điều khiển & Trợ năng",
  "settings.section.social": "Xã hội & Quyền riêng tư",
  "settings.section.danger": "Vùng nguy hiểm",
  "settings.musicVolume.label": "Âm lượng nhạc",
  "settings.soundVolume.label": "Âm lượng hiệu ứng",
  "settings.volume.decrease": "Giảm {label}",
  "settings.volume.increase": "Tăng {label}",
  "settings.volume.description": "Được lưu trên thiết bị này.",

  "settings.language.label": "Ngôn ngữ",
  "settings.language.description":
    "Chọn ngôn ngữ cho menu và thông báo. Tên lá bài và nội dung lá bài vẫn giữ tiếng Anh.",

  "settings.account.label": "Tài khoản",
  "settings.account.guestSuffix": " (Khách)",
  "settings.account.guestDescription":
    "Tiến trình của khách được lưu tối đa 24 giờ. Đăng xuất sẽ xóa vĩnh viễn dữ liệu khách này.",
  "settings.account.savedDescription":
    "Đã đăng nhập bằng tài khoản đã lưu trên thiết bị này.",
  "settings.account.createAndKeep": "Tạo tài khoản và giữ tiến trình",
  "settings.account.migratePrompt":
    "Tạo tài khoản và chuyển tiến trình hiện tại sang tài khoản đó.",
  "settings.account.username": "Tên người dùng",
  "settings.account.password": "Mật khẩu",
  "settings.account.migrating": "Đang chuyển…",
  "settings.account.createAccount": "Tạo tài khoản",
  "settings.account.changePasswordPrompt": "Đổi mật khẩu của bạn.",
  "settings.account.currentPassword": "Mật khẩu hiện tại",
  "settings.account.newPassword": "Mật khẩu mới",
  "settings.account.confirmNewPassword": "Xác nhận mật khẩu mới",
  "settings.account.saving": "Đang lưu…",
  "settings.account.updatePassword": "Cập nhật mật khẩu",
  "settings.account.changePassword": "Đổi mật khẩu",
  "settings.account.logOut": "Đăng xuất",
  "settings.account.logOutGuestConfirm":
    "Đăng xuất và xóa vĩnh viễn tài khoản khách này cùng toàn bộ tiến trình?",
  "settings.account.logOutConfirm":
    "Đăng xuất khỏi tài khoản này trên thiết bị này?",
  "settings.account.confirmLogOut": "Xác nhận đăng xuất",

  "settings.music.label": "Nhạc nền",
  "settings.music.description":
    "Phát nhạc nền. Nhạc menu và nhạc trận đấu là hai danh sách phát riêng, được phát ngẫu nhiên và chuyển tiếp mượt mà, kể cả khi vào hoặc rời trận.",

  "settings.sound.label": "Âm thanh",
  "settings.sound.description":
    "Phát hiệu ứng âm thanh khi rút bài và các sự kiện khác trong trận.",
  "settings.sound.skipTrack": "Chuyển bài tiếp theo",

  "settings.workshop.label": "Xưởng",
  "settings.workshop.description":
    "Hiện hoặc ẩn nút Xưởng trên thanh điều hướng.",

  "settings.quickUse.label": "Hiện Dùng nhanh",
  "settings.quickUse.description":
    "Bật/tắt nút tiêu hao nhanh để lấy tài nguyên và/hoặc tấn công. Tính năng này giúp bạn dùng trang bị hoặc kỹ năng thật nhanh khi bạn chỉ quan tâm đến hiệu quả, không phải chất lượng.",

  "settings.hints.label": "Gợi ý",
  "settings.hints.description":
    "Bật/tắt các nút gợi ý theo ngữ cảnh trong trận. Nhấn vào biểu tượng ? để xem giải thích về giao diện gần đó.",

  "settings.matchGuides.label": "Hướng dẫn trận đấu",
  "settings.matchGuides.auto": "Tự động",
  "settings.matchGuides.description":
    "Làm sáng các lá bài có thể chơi, trang bị và kỹ năng còn dùng được, cùng nút Kết thúc lượt, kèm hộp gợi ý có thể thu gọn khi đấu với CPU hoặc người chơi. Tự động sẽ hiện hướng dẫn cho tài khoản khách và {games} trận đầu tiên của bạn.",
  "settings.cardNames.label": "Tên lá bài",
  "settings.cardNames.description":
    "Hiện hoặc ẩn tên các lá bài trên tay và các lá bài đã đặt vào ô trang bị.",

  "settings.leftHanded.label": "Chế độ tay trái",
  "settings.leftHanded.description":
    "Trong trận, chuyển nút Kết thúc lượt và Biểu cảm sang bên trái và bài trên tay sang bên phải.",

  "settings.theme.label": "Giao diện",
  "settings.theme.dark": "Tối",
  "settings.theme.light": "Sáng",
  "settings.theme.description": "Chuyển đổi giữa các giao diện.",

  "settings.graphics.label": "Chất lượng đồ họa",
  "settings.graphics.auto": "Tự động",
  "settings.graphics.high": "Cao",
  "settings.graphics.medium": "Trung bình",
  "settings.graphics.low": "Thấp",
  "settings.graphics.description":
    "Chất lượng thấp hơn sẽ giảm chuyển động nền, foil động, hiệu ứng phát sáng và làm mờ để trận đấu mượt hơn trên thiết bị yếu. Tự động sẽ chọn mức phù hợp cho thiết bị này và hạ xuống nếu trận đấu bị giật. Lưu riêng cho từng thiết bị.",
  "settings.graphics.autoCurrent": "Đang dùng: {tier}.",
  "settings.graphics.autoLowered":
    "Đã hạ đồ họa xuống {tier} để trận đấu mượt hơn. Bạn có thể thay đổi trong Cài đặt.",

  "settings.foil.label": "Hiệu ứng foil",
  "settings.foil.minimum": "Tối thiểu",
  "settings.foil.maximum": "Tối đa",
  "settings.foil.description":
    "Tối đa sẽ tạo hiệu ứng ánh foil chuyển động trong Trình tạo bộ bài, trận đấu và màn tổng kết. Bộ sưu tập, Thư viện và các lưới dày đặc khác vẫn giữ tĩnh. Tối thiểu giữ hiệu ứng foil tĩnh ở mọi nơi. Tắt chỉ giữ lại các hiệu ứng màu tĩnh như thang xám hoặc màu thay thế.",

  "settings.toasts.label": "Thông báo nổi",
  "settings.toasts.cardOnly": "Chỉ lá bài",
  "settings.toasts.textOnly": "Chỉ chữ",
  "settings.toasts.all": "Tất cả",
  "settings.toasts.description":
    "Chọn các cửa sổ bật lên về trận đấu và hành động sẽ hiển thị. Tắt sẽ ẩn tất cả. Chỉ lá bài hiển thị bản xem trước lá bài nhỏ. Chỉ chữ hiển thị thông báo dạng chữ. Tất cả hiển thị cả hai.",

  "settings.toastSpeed.label": "Tốc độ thông báo",
  "settings.toastSpeed.fast": "Nhanh",
  "settings.toastSpeed.standard": "Tiêu chuẩn",
  "settings.toastSpeed.description":
    "Nhanh hiển thị thông báo trong chốc lát rồi mờ dần. Tiêu chuẩn giữ thời gian hiển thị thông thường. Nhấn hoặc bấm bất cứ lúc nào để đóng sớm.",
  "settings.handDisplay.label": "Hiển thị bài trên tay",
  "settings.handDisplay.drawer": "Ngăn kéo",
  "settings.handDisplay.dynamic": "Linh hoạt",
  "settings.handDisplay.description":
    "Ngăn kéo hiển thị đầy đủ bài trên tay; dùng mũi tên bên cạnh để hạ bài xuống chỉ còn thấy tên. Linh hoạt giữ bài ẩn một nửa và nâng lá bài lên khi bạn rê chuột hoặc chạm vào.",
  "match.view.hideHand": "Ẩn bài trên tay",
  "match.view.showHand": "Hiện bài trên tay",

  "settings.fullscreen.label": "Luôn toàn màn hình",
  "settings.fullscreen.description":
    "Buộc hiển thị toàn màn hình trên máy tính hoặc điện thoại, giúp ẩn thanh địa chỉ/URL.",

  "settings.controller.label": "Tay cầm",
  "settings.controller.connected": "Đã kết nối",
  "settings.controller.none": "Không phát hiện",
  "settings.controller.description":
    "Phím D-pad di chuyển giữa các mục cài đặt. Nhấn A để mở các lựa chọn của mục đó, rồi nhấn A để chọn giá trị. Ô nhập chữ sẽ mở bàn phím ảo (A để gõ, B để đóng). Select hoặc Start chuyển giữa thanh điều hướng và màn hình hiện tại.",

  "settings.chat.label": "Trò chuyện",
  "settings.chat.turnOff": "Tắt trò chuyện",
  "settings.chat.reviewTerms": "Xem điều khoản trò chuyện",
  "settings.chat.muted": "Tính năng trò chuyện đã bị vô hiệu hóa cho tài khoản của bạn.",
  "settings.chat.on":
    "Trò chuyện đang bật. Tắt trò chuyện sẽ ẩn tất cả tin nhắn và ngăn bạn gửi tin. Bạn sẽ cần xem và đồng ý lại điều khoản trò chuyện để bật lại.",
  "settings.chat.off":
    "Trò chuyện đang tắt. Hãy xem và đồng ý điều khoản trò chuyện để xem và gửi tin nhắn.",
  "settings.chat.locked":
    "Trò chuyện đang tắt. Tính năng sẽ mở khi tài khoản của bạn được ít nhất 24 giờ tuổi, hoặc sau khi bạn hoàn thành {games} trận mà không đầu hàng.",

  "settings.blocked.label": "Người chơi bị chặn",
  "settings.blocked.unblock": "Bỏ chặn",
  "settings.blocked.description":
    "Tin nhắn trò chuyện và biểu cảm trong trận của người chơi bị chặn sẽ bị ẩn, và họ không thể thách đấu bạn. Hãy chặn người chơi từ hồ sơ của họ trong Cộng đồng, Xếp hạng, trò chuyện hoặc bản xem trước người chơi trong trận.",

  "settings.adventure.label": "Phiêu lưu",
  "settings.adventure.reset": "Đặt lại Phiêu lưu",
  "settings.adventure.description":
    "Đặt lại Phiêu lưu sẽ xóa dữ liệu Phiêu lưu và cho phép bạn bắt đầu lại hoàn toàn. Nếu bạn đã bắt đầu chơi chế độ Phiêu lưu, toàn bộ dữ liệu Phiêu lưu sẽ bị đặt lại (bản đồ mới, kho đồ, không còn hiệu ứng, v.v.).",
  "settings.adventure.none": "Không có dữ liệu Phiêu lưu để đặt lại.",
  "settings.adventure.confirmTitle": "Đặt lại Phiêu lưu?",
  "settings.adventure.confirmBody":
    "Thao tác này sẽ xóa vĩnh viễn dữ liệu Phiêu lưu của bạn, bao gồm tiến trình bản đồ, Kho đồ, Bộ bài Phiêu lưu, Vàng và mọi cuộc chạm trán hoặc trận chiến Phiêu lưu đang diễn ra. Bạn sẽ bắt đầu lại từ đầu.",

  "settings.deleteAccount.label": "Xóa tài khoản",
  "settings.deleteAccount.description":
    "Xóa vĩnh viễn tài khoản này, thông tin đăng nhập và toàn bộ tiến trình. Không thể hoàn tác.",
  "settings.deleteAccount.typeUsername": "Nhập tên người dùng của bạn ({username})",
  "settings.deleteAccount.deleting": "Đang xóa…",
  "settings.deleteAccount.forever": "Xóa tài khoản vĩnh viễn",

  "deck.aspect": "Aspect",
  "deck.equipment": "Trang bị",
  "deck.ability": "Kỹ năng",
  "deck.defaultName": "Bộ bài",
  "deck.newDeck": "Bộ bài mới",
  "deck.totalPower": "Tổng Uy lực",
  "deck.filters.allCards": "Tất cả lá bài",
  "deck.filters.allAttributes": "Tất cả thuộc tính",
  "deck.attr.strength": "Sức mạnh",
  "deck.attr.dexterity": "Nhanh nhẹn",
  "deck.attr.wisdom": "Trí tuệ",
  "deck.attr.neutral": "Trung lập",
  "deck.filters.allResources": "Tất cả tài nguyên",
  "deck.filters.allCosts": "Tất cả chi phí",
  "deck.filters.allCostsResources": "Tất cả chi phí/tài nguyên",
  "deck.filters.fewer": "Ít bộ lọc hơn",
  "deck.filters.more": "Thêm bộ lọc",
  "deck.filters.holoUnlocked": "Holo đã mở khóa",
  "deck.filters.cardsUnlocked": "Lá bài: Đã mở khóa",
  "deck.filters.cardsLocked": "Lá bài: Chưa mở khóa",
  "deck.filters.cardsAll": "Lá bài: Tất cả",
  "deck.filters.clear": "Xóa bộ lọc",
  "deck.filters.searchPlaceholder": "Tìm theo tên, hiệu ứng, chi phí…",
  "deck.filters.allSlots": "Tất cả ô",
  "deck.filters.allItemTypes": "Tất cả loại trang bị",
  "deck.filters.allTiers": "Tất cả bậc",
  "deck.filters.allKinds": "Tất cả loại",
  "deck.kind.active": "Chủ động",
  "deck.kind.augment": "Cường hóa",
  "deck.kind.essence": "Tinh hoa",
  "deck.filters.allTypes": "Tất cả kiểu",
  "deck.filters.allEffects": "Tất cả hiệu ứng",
  "deck.filters.sortBy": "Sắp xếp: {label}",
  "deck.catalog.resultCount_other": "{count} lá bài",
  "deck.variant.label": "Biến thể",
  "deck.variant.base": "Cơ bản",
  "deck.variant.confirm": "Xác nhận",
  "deck.pager.previous": "Trang trước",
  "deck.pager.next": "Trang sau",
  "deck.pager.pageOf": "Trang {page}/{total}",
  "deck.pager.perPage": "{n} mỗi trang",
  "deck.pager.all": "Tất cả",
  "deck.share.exportTitle": "Xuất bộ bài",
  "deck.share.importTitle": "Nhập bộ bài",
  "deck.share.pastePlaceholder": "Dán JSON bộ bài",
  "deck.share.copied": "Đã sao chép",
  "deck.share.copy": "Sao chép",
  "deck.share.import": "Nhập",
  "deck.analyze.none": "Không có",
  "deck.analyze.noOutputs": "Không có đầu ra hành động nào đo được.",
  "deck.analyze.output": "Đầu ra",
  "deck.analyze.avgPerCard": "TB / lá",
  "deck.analyze.total": "Tổng",
  "deck.analyze.sectionMeta": "{count} lá bài · Uy lực {power}",
  "deck.analyze.avgCost": "Chi phí TB {cost}",
  "deck.analyze.kinds": "Loại",
  "deck.analyze.boardSlots": "Ô trên bàn",
  "deck.analyze.equipmentSlots": "Ô trang bị",
  "deck.analyze.attributes": "Thuộc tính",
  "deck.analyze.typesPresent": "Các kiểu có mặt",
  "deck.analyze.averageOutputs": "Đầu ra hành động trung bình",
  "deck.analyze.title": "Phân tích · {name}",
  "deck.analyze.overview": "{count} lá bài · Uy lực {power}/{max}",
  "deck.analyze.attributesLabel": "Thuộc tính:",
  "deck.analyze.typesLabel": "Kiểu:",
  "deck.analyze.aspectMeta": "{name} · Uy lực {power}",
  "deck.analyze.noneSelected": "Chưa chọn",
  "deck.analyze.types": "Kiểu",
  "deck.analyze.pickAspect": "Chọn một Aspect để hiển thị tại đây.",
  "deck.recommend.unknownCard": "Lá bài không xác định",
  "deck.recommend.title": "Đề xuất thay đổi · {name}",
  "deck.recommend.aspectUnchanged": "Aspect · Không đổi",
  "deck.recommend.swaps": "Hoán đổi",
  "deck.recommend.loading": "Đang tìm hoán đổi phù hợp…",
  "deck.recommend.emptyTitle": "Không tìm thấy hoán đổi phù hợp.",
  "deck.recommend.emptyBody": "Không có lá bài nào bạn sở hữu phù hợp hơn với bộ bài này mà không làm mất độ phủ ô, hỗ trợ tài nguyên hoặc dư địa Uy lực. Bộ bài của bạn không thay đổi.",
  "deck.recommend.staleNotice": "Bộ bài, dữ liệu lá bài hoặc bộ sưu tập của bạn đã thay đổi kể từ bản xem trước này.",
  "deck.recommend.recommendAgainHint": "Hãy đề xuất lại để có hoán đổi mới.",
  "deck.recommend.exhausted": "Không tìm thấy hoán đổi khác. Đề xuất trước đó vẫn đang được hiển thị.",
  "deck.recommend.equipmentSlot": "Ô trang bị {n}",
  "deck.recommend.abilitySlot": "Ô kỹ năng {n}",
  "deck.recommend.remove": "Bỏ ra",
  "deck.recommend.add": "Thêm vào",
  "deck.recommend.whyAdd": "Lý do thêm",
  "deck.recommend.whyRemove": "Lý do bỏ",
  "deck.recommend.disclaimer": "Đề xuất dựa trên liên kết giữa các lá bài và không đảm bảo là nâng cấp. Áp dụng sẽ cập nhật trình chỉnh sửa; hãy Lưu để giữ thay đổi.",
  "deck.recommend.apply": "Áp dụng thay đổi",
  "deck.recommend.again": "Đề xuất lại",
  "deck.recommend.tryAgain": "Thử lại",
  "deck.recommend.button": "Đề xuất thay đổi",
  "deck.recommend.buttonTitle": "Đề xuất 2–4 hoán đổi lá bài phù hợp",
  "deck.recommend.needsValidDeck": "Đề xuất thay đổi cần một bộ bài hoàn chỉnh và hợp lệ.",
  "deck.slot.empty": "Trống",
  "deck.slot.deckSlot": "Ô bộ bài",
  "deck.slot.clear": "Xóa ô",
  "deck.slot.replaceCard": "Thay lá bài",
  "deck.picker.replaceAspect": "Thay Aspect",
  "deck.picker.chooseAspect": "Chọn Aspect",
  "deck.picker.replaceEquipmentSlot": "Thay ô trang bị {n}",
  "deck.picker.chooseEquipmentSlot": "Chọn ô trang bị {n}",
  "deck.picker.replaceAbilitySlot": "Thay ô kỹ năng {n}",
  "deck.picker.chooseAbilitySlot": "Chọn ô kỹ năng {n}",
  "deck.picker.hideFilters": "Ẩn bộ lọc/tìm kiếm",
  "deck.picker.showFilters": "Hiện bộ lọc/tìm kiếm",
  "deck.picker.suggest": "Gợi ý lá bài",
  "deck.sort.name": "Sắp xếp: Tên",
  "deck.sort.type": "Sắp xếp: Kiểu",
  "deck.sort.attribute": "Sắp xếp: Thuộc tính",
  "deck.sort.resources": "Sắp xếp: Tài nguyên",
  "deck.sort.cost": "Sắp xếp: Chi phí",
  "deck.sort.power": "Sắp xếp: Uy lực",
  "deck.sort.slot": "Sắp xếp: Ô",
  "deck.sort.kind": "Sắp xếp: Loại",
  "deck.sort.holo": "Sắp xếp: Số Holo",
  "deck.builder.title": "Trình tạo bộ bài",
  "deck.builder.setDefault": "Đặt mặc định",
  "deck.builder.clone": "Nhân bản",
  "deck.builder.save": "Lưu",
  "deck.builder.delete": "Xóa",
  "deck.builder.export": "Xuất",
  "deck.builder.analyze": "Phân tích",
  "deck.builder.default": "Mặc định",
  "deck.builder.unsaved": "Chưa lưu",
  "deck.builder.deleteTitle": "Xóa bộ bài?",
  "deck.builder.deleteBody": "Xóa vĩnh viễn {name}. Thao tác này không thể hoàn tác.",
  "match.board.healthCost": "{amount} máu",
  "match.board.alreadyPlayedAbility": "Lượt này bạn đã chơi kỹ năng rồi.",
  "match.board.tagInherent": "nội tại",
  "match.board.tagCombo": "combo",
  "match.board.tagLevel": "Cấp {level}",
  "match.board.tagActiveMinion": "{name} đang hoạt động {hp}",
  "match.board.tagActiveAura": "{name} đang hoạt động",
  "match.board.slotTitleCanLevelUp": "Có thể lên cấp · chọn để xem thao tác",
  "match.board.slotTitleEmpowerArmor": "Tăng cường lá bài Giáp vật lý này",
  "match.board.slotTitleLinkedAugment": "Khớp Cường hóa liên kết",
  "match.board.slotTitleSlotHere": "Gắn kỹ năng vào đây",
  "match.board.mismatch": "Không khớp",
  "match.board.expendedSuffix": " · đã tiêu hao",
  "match.board.auraActiveTitle": "{name} · Hào quang đang hoạt động",
  "match.board.linkedActiveUsed": "{name} · kỹ năng chủ động liên kết đã dùng",
  "match.board.slotTitleInert": "{name} · không hoạt động ngoài ô chính",
  "match.board.costTitle": "Chi phí {cost}",
  "match.board.emptyAbilitySlot": "Ô kỹ năng trống",
  "match.board.fletchCounter_other": "{count} điểm nạp Fletch",
  "match.board.activeBadge": "Chủ động",
  "match.board.you": "BẠN",
  "match.board.opp": "ĐỐI THỦ",
  "match.board.timerMulligan": "Thời gian đổi bài đầu",
  "match.board.timerTurn": "Thời gian lượt",
  "match.board.timerMatch": "Thời gian trận đấu",
  "match.board.mulligan": "Đổi bài đầu",
  "match.board.yourTurn": "Lượt của bạn",
  "match.board.playerTurn": "Lượt của {name}",
  "match.board.firstPlayerWillBe": "Người đi trước: {name} · ",
  "match.board.round": "Vòng {round}",
  "match.board.peekEquipment": "Trang bị",
  "match.board.noEquipment": "Không có trang bị",
  "match.board.peekAbilities": "Kỹ năng",
  "match.board.noAbilities": "Không có kỹ năng",
  "match.board.noOccupiedSlots": "Không có ô nào được dùng",
  "match.board.healthOrbLabel": "Máu {hp}/{maxHp}",
  "match.board.quests": "Nhiệm vụ",
  "match.board.tapAgainToExpend": "Chạm lần nữa để tiêu hao: {action}",
  "match.board.targetAspect": "Chọn Aspect làm mục tiêu",
  "match.board.aspect": "Aspect",
  "match.board.aspectSlotLabel": "Ô Aspect",
  "match.board.aspectSlot": "Ô Aspect",
  "match.board.slotWeapon": "Vũ khí",
  "match.board.slotArmor": "Giáp",
  "match.board.slotTrinket": "Trang sức",
  "match.board.minion": "Tay sai",
  "match.board.aura": "Hào quang",
  "match.board.expend": "Tiêu hao",
  "match.board.minionHealthLabel": "{name} máu {hp}/{maxHp}",
  "match.board.auraActiveLabel": "{name} đang hoạt động",
  "match.board.hexed": "Bị yểm",
  "match.board.expendCost": "Tiêu hao +{cost}",
  "match.board.equipHere": "Trang bị vào đây",
  "match.board.slotTitle": "Ô {slot}",
  "match.board.slotAriaLabel": "Ô {slot}",
  "match.board.quickRefresh": "LÀM MỚI",
  "match.board.quickEncore": "ENCORE",
  "match.board.quickSlotDamage": "ST Ô",
  "match.board.quickRepair": "SỬA",
  "match.board.gainResources": "Nhận tài nguyên",
  "match.board.dealDamage": "Gây sát thương",
  "match.board.heal": "Hồi máu",
  "match.board.physicalArmor": "Giáp vật lý",
  "match.board.magicArmor": "Giáp phép",
  "match.board.resolveTargetingFirst": "Hãy chọn mục tiêu trước.",
  "match.board.equipmentBrokenCannotExpend": "Trang bị đó đã hỏng và không thể tiêu hao.",
  "match.board.equipmentCannotExpend": "Không thể tiêu hao trang bị đó.",
  "match.board.refreshRequiresExpended": "Làm mới cần trang bị đã tiêu hao.",
  "match.board.cannotUseAction": "Không thể dùng thao tác đó.",
  "match.board.equipmentAction": "Thao tác trang bị",
  "match.board.notEnoughPhysicalArmor": "Không đủ giáp vật lý.",
  "match.board.examine": "Xem chi tiết",
  "match.board.deactivateAura": "Hủy Hào quang",
  "match.board.effectFallback": "Hiệu ứng",
  "match.board.encore": "Encore",
  "match.board.slottedDamage": "+{amount} sát thương ô",
  "match.board.repair": "Sửa chữa",
  "match.board.equipmentNotExpended": "Trang bị chưa được tiêu hao.",
  "match.board.refresh": "Làm mới",
  "match.board.charge": "Nạp",
  "match.board.discard": "Bỏ",
  "match.board.levelUpAbility": "Nâng cấp kỹ năng",
  "match.board.empowerEquipment": "Cường hóa trang bị",
  "match.board.empowerAbility": "Cường hóa kỹ năng",
  "match.board.unsummon": "Hủy triệu hồi",
  "match.board.deactivate": "Hủy kích hoạt",
  "match.board.alreadyActivated": "Lượt này đã kích hoạt rồi.",
  "match.board.minionAlreadyActive": "Tay sai đã hoạt động.",
  "match.board.auraAlreadyActive": "Hào quang đã hoạt động.",
  "match.board.hostEquipmentOccupied": "Trang bị chủ đang bị chiếm.",
  "match.board.unsummonMinionFirst": "Hãy hủy triệu hồi tay sai trước.",
  "match.board.deactivateAuraFirst": "Hãy hủy hào quang trước.",
  "match.board.moveAbility": "Di chuyển kỹ năng",
  "match.board.remainingActs": "Hành động còn lại:",
  "match.board.remainingEquip": "Trang bị",
  "match.board.remainingAbility": "Kỹ năng",
  "match.board.remainingExpendGear": "Tiêu hao TB",
  "match.board.remainingActivateAbilities": "Kích hoạt KN",
  "match.board.hintEquip": "Mỗi lượt một lần, trang bị một lá bài Trang bị từ bài trên tay vào một ô cơ thể trống.",
  "match.board.hintAbility": "Mỗi lượt một lần, gắn một Kỹ năng từ bài trên tay lên bàn, hoặc di chuyển một Kỹ năng đã gắn sang ô trống. Bỏ một Kỹ năng đã gắn là miễn phí và không dùng hành động này.",
  "match.board.hintExpendGear": "Mỗi món đã trang bị có thể tiêu hao một lần mỗi lượt để nhận tài nguyên hoặc hiệu ứng tiêu hao. Nhiều lựa chọn tiêu hao trên cùng một món vẫn chỉ tính là một.",
  "match.board.hintActivateAbilities": "Số Kỹ năng Chủ động đã gắn chưa dùng và vẫn có thể kích hoạt trong lượt này. Bạn vẫn phải trả chi phí khi kích hoạt.",
  "match.board.notEnoughResources": "Không đủ tài nguyên.",
  "match.board.effectNumber": "Hiệu ứng {number}",
  "match.board.actionNumber": "Thao tác {number}",
  "match.board.noEmptyAbilitySlots": "Không còn ô kỹ năng trống.",
  "match.board.selectEmptyAbilitySlot": "Chọn một ô kỹ năng trống.",
  "match.panel.aspect": "Aspect",
  "match.panel.aspectEmpty": "Aspect · Trống",
  "match.panel.equipment": "Trang bị",
  "match.panel.slotEmpty": "{slot} · Trống",
  "match.panel.minion": "Tay sai",
  "match.panel.aura": "Hào quang",
  "match.panel.onEquipment": " · trên {name}",
  "match.panel.charges": "Điểm nạp",
  "match.panel.durability": "Độ bền",
  "match.panel.broken": " (Hỏng)",
  "match.panel.unsummon": "Hủy triệu hồi",
  "match.panel.deactivate": "Hủy kích hoạt",
  "match.panel.gain": "Nhận",
  "match.panel.toast.resolveTargetingFirst": "Hãy chọn mục tiêu trước.",
  "match.panel.toast.notEnoughPhysicalArmor": "Không đủ giáp vật lý.",
  "match.panel.toast.refreshRequiresExpended": "Làm mới yêu cầu trang bị đã tiêu hao.",
  "match.panel.toast.equipmentCannotExpend": "Không thể tiêu hao trang bị đó.",
  "match.panel.toast.resolvePendingChoiceFirst": "Hãy hoàn tất lựa chọn đang chờ trước.",
  "match.panel.refresh": "Làm mới",
  "match.panel.charge": "Nạp",
  "match.panel.encore": "Encore",
  "match.panel.slottedDamageButton": "+{amount} Sát thương ô",
  "match.panel.repair": "Sửa chữa",
  "match.panel.discard": "Bỏ bài",
  "match.panel.examine": "Xem chi tiết",
  "match.panel.traits": "Đặc tính",
  "match.panel.aspectTraitTreeAria": "Cây đặc tính {name}",
  "match.panel.levelTrait": "Đặc tính cấp {level}",
  "match.panel.levelTraitLabel": "Cấp {level}: {label}",
  "match.panel.aspectBaseEffect": "Hiệu ứng cơ bản của Aspect",
  "match.panel.allocated": "Đã chọn",
  "match.panel.traitOption": "Lựa chọn đặc tính",
  "match.panel.clickAnywhereToClose": "Nhấn vào bất kỳ đâu để đóng",
  "match.panel.tapNodeHint": "Chạm vào một nút để xem Đặc tính và hiệu ứng cơ bản của Aspect.",
  "match.panel.viewArtAria": "Xem ảnh {name}",
  "match.panel.variant": "Biến thể",
  "match.panel.variantBase": "Cơ bản",
  "match.panel.expansionSetAria": "Bộ mở rộng {set}",
  "match.panel.set": "Bộ",
  "match.panel.power": "Uy lực",
  "match.panel.attributes": "Thuộc tính",
  "match.panel.attribute": "Thuộc tính",
  "match.panel.kind": "Loại",
  "match.panel.linksTo": "Liên kết với",
  "match.panel.or": "hoặc",
  "match.panel.matchingActiveAbilities": "Kỹ năng chủ động phù hợp",
  "match.panel.slot": "Ô",
  "match.panel.boardSlotSub": "Ô trên bàn: {slot}",
  "match.panel.matchEffect": "Hiệu ứng trận đấu",
  "match.panel.passive": "Bị động",
  "match.panel.kindEffect": "Hiệu ứng {kind}",
  "match.panel.effect": "Hiệu ứng",
  "match.panel.effectLower": "hiệu ứng",
  "match.panel.triggers": "Điều kiện kích hoạt",
  "match.panel.expend": "Tiêu hao",
  "match.panel.equipmentActions": "Hành động trang bị",
  "match.panel.cardText": "Văn bản lá bài",
  "match.panel.invoke": "Khẩn cầu",
  "match.panel.levelProgression": "Tiến trình cấp",
  "match.panel.traitTree": "Cây đặc tính",
  "match.panel.tapArtToEnlarge": "Chạm vào ảnh để phóng to",
  "match.panel.ability": "Kỹ năng",
  "match.panel.health": "Máu",
  "match.panel.expendedThisTurn": "Đã tiêu hao lượt này",
  "match.panel.minions": "Tay sai",
  "match.panel.hostEquipment": "Trang bị chủ · {name}",
  "match.panel.appliedEffects": "Hiệu ứng đang áp dụng",
  "match.panel.applyAbility": "Áp dụng {name}",
  "match.panel.used": "Đã dùng",
  "match.panel.activeMinionStatus": "Đang hoạt động {name} {hp}",
  "match.panel.activeStatus": "Đang hoạt động {name}",
  "match.panel.mismatch": "Không khớp",
  "match.panel.level": "Cấp",
  "match.panel.baseLevel": "Gốc {level}",
  "match.panel.status": "Trạng thái",
  "match.panel.levelUpAbility": "Nâng cấp kỹ năng",
  "match.panel.exportGameLogTitle": "Tải bản chụp JSON của Nhật ký trận đến hiện tại",
  "match.panel.exporting": "Đang xuất…",
  "match.panel.export": "Xuất",
  "match.panel.noActionsYet": "Chưa có hành động nào.",
  "match.panel.quests": "Nhiệm vụ",
  "match.panel.eachTurn": "Mỗi lượt",
  "match.panel.eachTurnHint": "Hoàn thành theo thứ tự bất kỳ. Đặt lại khi bắt đầu lượt tiếp theo của bạn.",
  "match.panel.duringGame": "Trong trận đấu",
  "match.panel.duringGameHint": "Hoàn thành một lần mỗi trận, theo thứ tự bất kỳ.",
  "match.panel.chooseSlottedResource": "Chọn tài nguyên khớp với một kỹ năng đã gắn.",
  "match.panel.convertNeutral": "Chuyển 1 Trung lập thành thuộc tính tùy chọn.",
  "match.panel.chooseFocusResourcePrompt": "Chọn Sức mạnh, Nhanh nhẹn hoặc Trí tuệ. Nhận 1 tài nguyên đó.",
  "match.panel.chooseIdentity": "Chọn bản sắc",
  "match.panel.chooseIdentityPrompt": "Chọn bản sắc. Khi được trang bị, trang bị này mang thuộc tính chính đã chọn.",
  "match.panel.levelUp": "Lên cấp",
  "match.panel.levelN": "Cấp {level}",
  "match.panel.tierN": "Bậc {tier}",
  "match.panel.tier": "Bậc",
  "match.panel.selected": "Đã chọn",
  "match.panel.notChosen": "Không được chọn",
  "match.panel.futureChoice": "Lựa chọn sau này",
  "match.panel.traitChoiceHint": "Chọn một nút đang sáng, rồi Xác nhận để chốt Đặc tính.",
  "match.panel.traitTreeAria": "Cây đặc tính",
  "match.panel.viewBoard": "Xem bàn",
  "match.panel.confirmTrait": "Xác nhận đặc tính",
  "match.panel.clickOutsideToClose": "Nhấn ra ngoài để đóng",
  "match.panel.showLevelUpPrompt": "Hiện lời nhắc lên cấp",
  "match.panel.hideLevelUpPrompt": "Ẩn lời nhắc lên cấp",
  "match.panel.levelUpAbilityPrompt": "Chọn một Kỹ năng {attribute} được đánh dấu rồi chọn Nâng cấp kỹ năng hoặc Bỏ qua để nhận +3 XP.",
  "match.panel.empowerPhysicalArmorCard": "Cường hóa lá bài Giáp vật lý",
  "match.panel.empowerEquipment": "Cường hóa trang bị",
  "match.panel.empowerPhysicalArmorHint": "Chọn một kỹ năng đã gắn được tô vàng có cấp Giáp vật lý để Lên cấp, hoặc trang bị được tô vàng có hiệu ứng tiêu hao cấp Giáp vật lý để tăng lượng giáp đó thêm 1 (giáp bị động không đổi), hoặc Bỏ qua để nhận +3 XP.",
  "match.panel.empowerEquipmentHint": "Chọn một trang bị Trí tuệ được tô vàng có cấp Giáp phép để tăng cả Giáp phép bị động lẫn Giáp phép khi tiêu hao thêm 1, hoặc Bỏ qua để nhận +3 XP.",
  "match.panel.chargeResourceSpend": "{label}: {current}. Tiêu {per} cho mỗi lần để nhận Sức mạnh, Nhanh nhẹn hoặc Trí tuệ.",
  "match.panel.allocateUpTo": "Phân bổ tối đa {max}. Còn lại {remaining}.",
  "match.panel.maxValue": "tối đa {max}",
  "match.panel.confirm": "Xác nhận",
  "match.panel.payFor": "Thanh toán cho {name}",
  "match.panel.spendAnyFlex": "Tiêu bất kỳ {amount} từ sức mạnh, nhanh nhẹn, trí tuệ hoặc trung lập",
  "match.panel.remaining": "Còn lại {amount}",
  "match.panel.decreaseAria": "Giảm {attribute}",
  "match.panel.increaseAria": "Tăng {attribute}",
  "match.panel.hiddenCard": "Lá bài ẩn",
  "match.panel.discardAndDraw": "Bỏ & Rút bài",
  "match.panel.equip": "Trang bị",
  "match.panel.slotAction": "Gắn",
  "match.panel.plusOnePhysArmor": "+1 Giáp vật lý",
  "match.view.enemies": "Kẻ địch",
  "match.view.statusBleed": "Chảy máu {amount}",
  "match.view.statusPoison": "Độc {amount}",
  "match.view.statusBurn": "Bỏng {amount}",
  "match.view.statusChill": "Lạnh cóng {amount}",
  "match.view.statusShock": "Sốc điện {amount}",
  "match.view.statusWither": "Héo mòn {amount}",
  "match.view.statusHex": "Nguyền rủa {amount}",
  "match.view.statusRegen": "Hồi phục {amount}",
  "match.view.regeneration": "Hồi phục",
  "match.view.wither": "Héo mòn",
  "match.view.enemyDefeated": "Đã bị hạ",
  "match.view.enemySelectedTarget": "Mục tiêu đã chọn",
  "match.view.enemySelect": "Chọn kẻ địch",
  "match.view.enemyExamine": "Xem chi tiết kẻ địch",
  "match.view.emptyEnemySlotAria": "Ô kẻ địch trống {slot}",
  "match.view.emptySlot": "Trống",
  "match.view.matchOver": "Trận đấu kết thúc",
  "match.view.waitingForSummary": "Đang chờ tổng kết…",
  "match.view.resultDraw": "Hòa",
  "match.view.endedTimeout": "Hết giờ",
  "match.view.endedCombat": "Chiến đấu",
  "match.view.tutorialComplete": "Hoàn thành hướng dẫn",
  "match.view.tryAgain": "Thử lại",
  "match.view.victory": "Chiến thắng",
  "match.view.defeat": "Thất bại",
  "match.view.deckPower": "Uy lực {total}/{max}",
  "match.view.deckAspectPower": "Aspect · Uy lực {power}",
  "match.view.deckEquipmentPower": "Trang bị ({cards}) · Uy lực {power}",
  "match.view.deckAbilitiesPower": "Kỹ năng ({cards}) · Uy lực {power}",
  "match.view.noneRemaining": "Không còn lá nào",
  "match.view.you": "Bạn",
  "match.view.winner": "Người thắng",
  "match.view.board": "Bàn đấu",
  "match.view.handCount": "Bài trên tay ({n})",
  "match.view.deckCount": "Bộ bài ({n})",
  "match.view.discardCount": "Bài bỏ ({n})",
  "match.view.continue": "Tiếp tục",
  "match.view.adNotCompleted": "Quảng cáo chưa được xem hết.",
  "match.view.adStartFailed": "Không thể bắt đầu quảng cáo.",
  "match.view.adExtraUnlock": "Xem quảng cáo để mở khóa thêm",
  "match.view.unlockedCards_other": "Đã mở khóa {count} lá bài",
  "match.view.unlockedFoils_other": "Đã mở khóa {count} phần thưởng foil",
  "match.view.bonusAvailable": "Có {bonus} phần thưởng thêm",
  "match.view.earned": "Nhận được",
  "match.view.adPromptTitle": "Xem quảng cáo?",
  "match.view.adPromptBody": "Bạn có muốn xem một quảng cáo ngắn để mở khóa thêm phiên bản foil của các lá bài đã mở khóa không? Chúng tôi sẽ dùng tiền quảng cáo để chi trả chi phí máy chủ và tiếp tục phát triển trò chơi. Cảm ơn bạn trước vì sự ủng hộ!",
  "match.view.loading": "Đang tải...",
  "match.view.adWatch": "Xem quảng cáo",
  "match.view.notNow": "Để sau",
  "match.view.none": "Không có",
  "match.view.endedBy": "Kết thúc bởi",
  "match.view.rounds": "Số vòng",
  "match.view.opponent": "Đối thủ",
  "match.view.damageDealt": "Sát thương gây ra",
  "match.view.damageTaken": "Sát thương nhận vào",
  "match.view.healed": "Đã hồi máu",
  "match.view.throwAway": "Vứt bỏ",
  "match.view.reportChooseCategory": "Hãy chọn danh mục báo cáo.",
  "match.view.chatTurnedOff": "Trò chuyện đã tắt. Xem lại điều khoản trò chuyện để bật lại.",
  "match.view.queueTitle": "Đang tìm trận đấu với người chơi...",
  "match.view.playersInQueue": "Người chơi đang chờ: {players}",
  "match.view.cancelQueue": "Hủy tìm trận",
  "match.view.discardPileAria": "Bài bỏ của {name}",
  "match.view.discardViewerHint": "Mới nhất trước. Chạm vào một lá bài để xem chi tiết.",
  "match.view.discardEmpty": "Không có lá bài nào trong bài bỏ.",
  "match.view.account.passwordTooShort": "Mật khẩu phải có ít nhất 4 ký tự.",
  "match.view.account.passwordMismatch": "Mật khẩu mới không khớp.",
  "match.view.account.passwordUpdated": "Đã cập nhật mật khẩu.",
  "match.view.account.changePasswordFailed": "Không thể đổi mật khẩu.",
  "match.view.account.requestFailed": "Yêu cầu thất bại.",
  "match.view.account.typeUsernameToConfirm": "Nhập chính xác tên người dùng của bạn để xác nhận.",
  "match.view.account.enterCurrentPassword": "Nhập mật khẩu hiện tại của bạn.",
  "match.view.account.deleteFailed": "Không thể xóa tài khoản.",
  "match.view.account.enterUsername": "Nhập tên người dùng.",
  "match.view.account.usernameNoSpaces": "Tên người dùng không được chứa khoảng trắng.",
  "match.view.account.createFailed": "Không thể tạo tài khoản.",
  "match.view.winnerBanner": "Người thắng: {name}",
  "match.view.quickUseEquipment": "Dùng nhanh trang bị lấy tài nguyên",
  "match.view.quickUseAbilities": "Dùng nhanh kỹ năng sát thương",
  "match.view.hand": "Bài trên tay",
  "match.view.noCardsInHand": "Không có lá bài nào trên tay",
  "match.view.handHint": "Đây là bài trên tay của bạn. Bộ bài trang bị và bộ bài kỹ năng được xáo chung với nhau. Bạn có thể giữ tối đa bốn lá bài trên tay, được bổ sung đến mức tối đa vào đầu mỗi lượt của bạn. Mỗi lượt bạn có thể trang bị một lá trang bị và thực hiện một thao tác kỹ năng: gắn vào ô trống, di chuyển một kỹ năng đã gắn, hoặc gỡ về tay.",
  "match.guide.label": "Hướng dẫn",
  "match.guide.show": "Hiện hướng dẫn",
  "match.guide.hide": "Thu nhỏ hướng dẫn",
  "match.guide.turnOff": "Tắt hướng dẫn",
  "match.guide.turnedOff": "Đã tắt hướng dẫn trận đấu. Bật lại trong Cài đặt.",
  "match.guide.title.openingHand": "Bài khởi đầu",
  "match.guide.title.yourTurn": "Lượt của bạn",
  "match.guide.title.opponentTurn": "Lượt đối thủ",
  "match.guide.title.makeChoice": "Hãy lựa chọn",
  "match.guide.mulligan": "Giữ bài này, hoặc bấm Đổi bài đầu một lần để rút lại. Bấm Sẵn sàng khi bạn đã xong.",
  "match.guide.mulliganWaiting": "Đang chờ đối thủ sẵn sàng.",
  "match.guide.opponentTurn": "Theo dõi những gì đối thủ chơi. Chạm vào lá bài bất kỳ để xem chi tiết. Bài trên tay được bổ sung vào đầu lượt của bạn.",
  "match.guide.pendingChoice": "Hoàn tất lựa chọn đang được làm sáng (chọn mục tiêu hoặc tùy chọn), hoặc hủy nó, trước khi làm việc khác.",
  "match.guide.playEquipment": "Trang bị: chạm vào lá Trang bị đang sáng trên tay và bấm Trang bị (1 lần mỗi lượt).",
  "match.guide.slotAbility": "Kỹ năng: chạm vào lá Kỹ năng đang sáng trên tay, bấm Gắn, rồi chọn một ô kỹ năng trống (1 lần mỗi lượt).",
  "match.guide.expendEquipment_one": "Tiêu hao: chạm vào trang bị đang sáng trên bàn để nhận tài nguyên hoặc hiệu ứng.",
  "match.guide.expendEquipment_other": "Tiêu hao: chạm vào các trang bị đang sáng trên bàn để nhận tài nguyên hoặc hiệu ứng (còn {count}).",
  "match.guide.activateAbilities_one": "Kích hoạt: chạm vào kỹ năng đang sáng trên bàn để sử dụng.",
  "match.guide.activateAbilities_other": "Kích hoạt: chạm vào các kỹ năng đang sáng trên bàn để sử dụng (còn {count}).",
  "match.guide.needResources": "Một số kỹ năng cần thêm tài nguyên. Hãy tiêu hao trang bị trước để trả chi phí.",
  "match.guide.nothingLeft": "Không còn gì để chơi hoặc dùng. Bấm Kết thúc lượt.",
  "match.guide.idle": "Bí rồi? Bạn có thể bấm Kết thúc lượt bất cứ lúc nào.",
  "match.guide.invoke": "Tùy chọn: Khẩn cầu một lá trên tay, bỏ lá đó để dùng hiệu ứng Khẩn cầu của nó.",
  "match.view.viewingYourBoard": "Đang xem bàn đấu của bạn",
  "match.view.viewingEnemies": "Đang xem kẻ địch",
  "match.view.viewingPlayerBoard": "Đang xem bàn đấu của {name}",
  "match.view.cycleBoardView": "Chuyển chế độ xem bàn đấu",
  "match.view.viewLabel": "Xem",
  "match.view.viewEnemy": "Địch",
  "match.view.viewAlly": "Đồng minh",
  "match.view.viewOpp": "Đối thủ",
  "match.view.viewSelf": "Mình",
  "match.view.showMatchEmotes": "Hiện biểu cảm trong trận",
  "match.view.hideAllMatchEmotes": "Ẩn tất cả biểu cảm trong trận",
  "match.view.showEmotes": "Hiện biểu cảm",
  "match.view.hideEmotes": "Ẩn biểu cảm",
  "match.view.emotes": "Biểu cảm",
  "match.view.sendEmote": "Gửi biểu cảm {emoji}",
  "match.view.mulliganed": "Đã đổi bài đầu",
  "match.view.mulligan": "Đổi bài đầu",
  "match.view.closeEmotes": "Đóng biểu cảm",
  "match.view.openEmotes": "Mở biểu cảm",
  "match.view.emote": "Biểu cảm",
  "match.view.ready": "Sẵn sàng",
  "match.view.cancelEffectUse": "Hủy dùng hiệu ứng",
  "match.view.cancelAbilityUse": "Hủy dùng kỹ năng",
  "match.view.cancelEffectUseConfirm": "Hủy dùng hiệu ứng?",
  "match.view.cancelAbilityUseConfirm": "Hủy dùng kỹ năng?",
  "match.view.skipAbilityLevelUpTitle": "Bỏ qua tăng cấp kỹ năng để nhận +3 XP",
  "match.view.skip": "BỎ QUA",
  "match.view.chooseAbilityOrSkipTitle": "Chọn một kỹ năng được làm nổi bật hoặc Bỏ qua trước khi kết thúc lượt",
  "match.view.endTurnLine1": "KẾT THÚC",
  "match.view.endTurnLine2": "LƯỢT",
  "match.view.skipEquipmentTraitTitle": "Bỏ qua đặc tính trang bị để nhận +3 XP",
  "match.view.chooseAbilityOrEquipmentOrSkipTitle": "Chọn kỹ năng hoặc trang bị được làm nổi bật, hoặc Bỏ qua trước khi kết thúc lượt",
  "match.view.chooseEquipmentOrSkipTitle": "Chọn trang bị được làm nổi bật hoặc Bỏ qua trước khi kết thúc lượt",
  "match.view.chooseTraitLine1": "Chọn",
  "match.view.chooseTraitLine2": "Đặc tính",
  "match.view.viewBoardLine1": "Xem",
  "match.view.viewBoardLine2": "Bàn đấu",
  "match.view.chooseTraitTitle": "Chọn một Đặc tính trước khi kết thúc lượt",
  "match.view.chooseIdentityLine1": "Chọn",
  "match.view.chooseIdentityLine2": "Bản sắc",
  "match.view.chooseIdentityTitle": "Chọn một Bản sắc trước khi kết thúc lượt",
  "match.view.noResourcesSpent": "Sẽ không tốn tài nguyên nào.",
  "match.view.noRefund": "Bạn sẽ không được hoàn lại chi phí của {name}.",
  "match.view.thisEffect": "hiệu ứng này",
  "match.view.keepTargeting": "Tiếp tục chọn mục tiêu",
  "game.toast.error": "Lỗi",
  "game.toast.yourTurn": "Lượt của bạn",
  "game.toast.yourTurnOpeningBlocked": "Lượt của bạn · Bạn đi trước nên không gây sát thương trong lượt đầu tiên",
  "game.gameLog.exportFailed": "Không thể xuất Nhật ký trận.",
  "game.gameLog.copied": "Đã sao chép Nhật ký trận vào bộ nhớ tạm ({entries} mục)",
  "game.gameLog.exported": "Đã xuất Nhật ký trận ({entries} mục)",
  "game.payment.kind.ability": "Kỹ năng",
  "game.payment.kind.sharpen": "Mài sắc",
  "game.payment.kind.hone": "Rèn giũa",
  "game.payment.kind.fletch": "Chế tên",
  "game.payment.kind.encore": "Encore",
  "game.payment.kind.research": "Nghiên cứu",
  "game.payment.kind.repair": "Sửa chữa",
  "game.deck.recommendStale": "Bộ bài của bạn đã thay đổi. Hãy gợi ý lại để nhận phương án hoán đổi mới.",
  "game.deck.recommendInvalid": "Các phương án hoán đổi này không còn hợp lệ.",
  "game.deck.recommendApplied_other": "Đã áp dụng {count} hoán đổi. Hãy lưu để giữ lại.",
  "game.deck.limitReached": "Đã đạt giới hạn số bộ bài.",
  "game.deck.imported": "Đã nhập {name}",
  "game.workshop.seatOpponent": "Đối thủ",
  "game.workshop.seatYou": "Bạn",
  "game.workshop.maxCopies": "Tối đa {max} bản của {name}.",
  "game.workshop.addedToAbilityHand": "Đã thêm vào bài kỹ năng trên tay. Hãy chọn một ô.",
  "common.attribute.strength": "Sức mạnh",
  "common.attribute.dexterity": "Nhanh nhẹn",
  "common.attribute.wisdom": "Trí tuệ",
  "common.attribute.neutral": "Trung lập",
  "deck.sort.name": "Tên",
  "deck.sort.category": "Danh mục",
  "deck.sort.type": "Phân loại",
  "deck.sort.attribute": "Thuộc tính",
  "deck.sort.resources": "Tài nguyên",
  "deck.sort.cost": "Chi phí",
  "deck.sort.power": "Uy lực",
  "deck.sort.slot": "Ô",
  "deck.sort.tier": "Bậc",
  "deck.sort.kind": "Loại",
  "deck.sort.holo": "Số lượng Holo",
  "match.quest.equip": "Trang bị một lá Trang bị",
  "match.quest.slotAbility": "Gắn một lá Kỹ năng vào ô",
  "match.quest.resourceExpend": "Nhận ít nhất 1 tài nguyên",
  "match.quest.combatDamage": "Gây sát thương không bị chặn",
  "match.quest.healBuff": "Nhận một hiệu ứng hỗ trợ như hồi máu hoặc giáp",
  "match.quest.fullEquipment": "Có trang bị ở cả 3 ô cùng lúc",
  "match.quest.fullAbilities": "Có kỹ năng ở cả 3 ô chủ động hoặc chính cùng lúc",
  "match.quest.equipAllSlots": "Trang bị mỗi vị trí trang bị ít nhất một lần",
  "match.quest.activateLevel2Ability": "Kích hoạt một Kỹ năng cấp 2 đã gắn một lần",
  "match.quest.activateAugmentedAbility": "Kích hoạt một Kỹ năng có Cường hóa phù hợp một lần",
  "match.questStep.weapon": "Vũ khí",
  "match.questStep.trinket": "Trang sức",
  "match.questStep.body": "Thân",
  "match.questStep.hands": "Tay",
  "match.questStep.feet": "Chân",
  "match.questStep.head": "Đầu",
  "game.serverToast.mulliganFirstPlayer": "GIAI ĐOẠN ĐỔI BÀI - Người đi trước là {name}",
  "game.serverToast.ranOutOfTime": "Bạn đã hết thời gian!",
  "match.lobby.backToMatch": "Quay lại trận đấu",
  "match.lobby.classic": "Cổ điển",
  "match.lobby.queueVsCpu": "Đấu với CPU",
  "match.lobby.vsCpu": "VS CPU",
  "match.lobby.playersInQueue_other": "Người chơi đang chờ: {count}",
  "match.lobby.queueVsHuman": "Đấu với người chơi",
  "match.lobby.vsHuman": "VS Người chơi",
  "match.lobby.cancelQueue": "Hủy chờ",
  "match.lobby.enterQueueVsHuman": "Vào hàng chờ đấu người chơi",
  "match.lobby.playAgainstCpu": "Đấu với CPU",
  "match.lobby.setValidDeck": "Hãy chọn một bộ bài hợp lệ trước khi vào hàng chờ.",
  "match.lobby.currentDeck": "Bộ bài hiện tại:",
  "match.lobby.randomDeck": "🎲 Bộ bài ngẫu nhiên",
  "match.lobby.randomDeckHint": "Một bộ bài hợp lệ ngẫu nhiên sẽ được chọn khi bạn vào hàng chờ.",
  "match.lobby.deckPreview": "Xem trước bộ bài",
  "match.lobby.noAspect": "Không có Aspect",
  "match.lobby.modes": "Chế độ",
  "match.lobby.collectDraftRewards": "Nhận thưởng Draft",
  "match.lobby.continueDraftMode": "Tiếp tục chế độ Draft",
  "match.lobby.playDraftModeFree": "Chơi chế độ Draft (MIỄN PHÍ)",
  "match.lobby.playDraftModeCost": "Chơi chế độ Draft ({cost} tiền tệ)",
  "match.lobby.collectDraft": "Nhận thưởng Draft",
  "match.lobby.continueDraft": "Tiếp tục Draft",
  "match.lobby.draftFree": "Draft (MIỄN PHÍ)",
  "match.lobby.draft": "Draft",
  "match.lobby.continueAdventureMode": "Tiếp tục chế độ Phiêu lưu",
  "match.lobby.playAdventureMode": "Chơi chế độ Phiêu lưu",
  "match.lobby.continueAdventure": "Tiếp tục Phiêu lưu",
  "match.lobby.adventure": "Phiêu lưu",
  "match.lobby.tutorialScenarios": "Kịch bản hướng dẫn",
  "match.lobby.tutorials": "Hướng dẫn",
  "match.lobby.draftStatus": "Draft: {lives} mạng · {played}/{max} trận · Thắng {wins} / Thua {losses} / Hòa {draws}",
  "match.lobby.draftRound": "Draft: Vòng {round}/{total}",
  "match.lobby.collectDraftFirst": "Hãy nhận thưởng Draft trước khi bắt đầu lượt mới.",
  "match.popup.challengeTitle": "Lời thách đấu",
  "match.popup.challengeBody": "{name} đã thách đấu bạn.",
  "match.popup.partyInviteTitle": "Lời mời tổ đội",
  "match.popup.partyInviteBody": "{name} đã mời bạn vào tổ đội Phiêu lưu.",
  "match.popup.leaveCpuTitle": "Rời trận đấu CPU?",
  "match.popup.leaveCpuBody": "Đầu hàng và rời trận này để nhận lời thách đấu?",
  "match.popup.accept": "Chấp nhận",
  "match.popup.decline": "Từ chối",
  "match.popup.leaveSpectateTitle": "Thoát chế độ xem?",
  "match.popup.forfeitTitle": "Đầu hàng?",
  "match.popup.leaveSpectateBody": "Bạn sẽ ngừng xem trận đấu này.",
  "match.popup.forfeitBody": "Bạn sẽ thua trận này và rời đi ngay lập tức.",
  "match.popup.leave": "Rời đi",
  "match.popup.forfeit": "Đầu hàng",
  "match.popup.loseTitle": "Việc này sẽ khiến bạn thua",
  "match.popup.loseBodyEquip": "Trang bị {name} sẽ khiến bạn thua.",
  "match.popup.loseBodyActivate": "Kích hoạt {name} sẽ khiến bạn thua.",
  "match.popup.confirm": "Xác nhận",
  "match.popup.disconnected": "Mất kết nối",
  "match.popup.reconnecting": "Bạn đã mất kết nối, đang thử kết nối lại...",
  "match.popup.hideHint": "Ẩn gợi ý",
  "common.back": "Quay lại",
  "common.returnToMenu": "Về menu",
  "common.currencyAmount": "{amount} tiền tệ",
  "draft.title": "Chế độ Draft",
  "draft.draftedCards": "Các lá đã Draft",
  "draft.aspectCount": "Aspect ({n})",
  "draft.equipmentCount": "Trang bị ({n})",
  "draft.abilityCount": "Kỹ năng ({n})",
  "draft.noneYet": "Chưa có.",
  "draft.roundChoice": "Vòng {round}/{total} · Chọn {kind}",
  "draft.forfeit": "Bỏ Draft",
  "draft.pick": "Chọn",
  "draft.forfeitTitle": "Bỏ Draft?",
  "draft.forfeitBody": "Thao tác này sẽ kết thúc toàn bộ lượt Draft.",
  "draft.deckTitle": "Bộ bài Draft",
  "draft.deckStatus": "Mạng {lives}/{maxLives} · Trận {played}/{maxGames} · Thắng {wins} / Thua {losses} / Hòa {draws}",
  "draft.deckCounts": "Aspect {aspect}/1 · Trang bị {equipment}/{min} · Kỹ năng {ability}/{min} · Kho: {poolAspect} Aspect / {poolEquipment} trang bị / {poolAbility} kỹ năng",
  "draft.queueCpu": "Đấu Draft với CPU",
  "draft.queueHuman": "Tìm trận Draft với người chơi",
  "draft.buildHint": "Xây bộ bài gồm 10 trang bị / 10 kỹ năng từ các lá bạn đã Draft.",
  "draft.complete": "Hoàn tất Draft",
  "draft.collectRewards": "Nhận thưởng",
  "draft.livesRemaining": "Mạng còn lại {lives}",
  "draft.record": "Thắng {wins} / Thua {losses} / Hòa {draws}",
  "draft.games": "Số trận {games}",
  "draft.reward": "Phần thưởng",
  "draft.wizardFoils": "Foil Phù thủy Draft {n}",
  "draft.deckAspect": "Aspect trong bộ bài",
  "draft.deckEquipment": "Trang bị trong bộ bài",
  "draft.deckAbility": "Kỹ năng trong bộ bài",
  "draft.poolAspect": "Aspect trong kho",
  "draft.poolEquipment": "Trang bị trong kho",
  "draft.poolAbility": "Kỹ năng trong kho",
  "draft.costToast": "Chế độ Draft tốn {cost} tiền tệ (hoặc miễn phí mỗi ngày một lần sau 16:00 giờ miền Trung Hoa Kỳ).",
  "adventure.title": "Chế độ Phiêu lưu",
  "adventure.hp": "{hp}/{maxHp} HP",
  "adventure.gold": "Vàng {gold}",
  "adventure.intention": "Ý định: {intention}",
  "adventure.actsEvery_other": "Hành động mỗi {count} lượt",
  "adventure.nextSuffix": " (tiếp theo)",
  "adventure.intentNext": "Tiếp theo: {summary}",
  "adventure.intentIn": "Sau {turns} lượt: {summary}",
  "adventure.unknown": "Không rõ",
  "adventure.attack": "Tấn công",
  "adventure.attackDamage": "{damage} sát thương {type}",
  "adventure.attackHeal": "hồi {heal} ({target})",
  "adventure.healTargetAllies": "toàn bộ đồng minh",
  "adventure.healTargetAlly": "một đồng minh",
  "adventure.healTargetSelf": "bản thân",
  "adventure.damageType.physical": "vật lý",
  "adventure.damageType.magical": "phép",
  "adventure.damageType.fire": "lửa",
  "adventure.damageType.cold": "băng",
  "adventure.damageType.lightning": "sét",
  "adventure.enemy": "Kẻ địch",
  "adventure.enemyType": "Loại: {name}",
  "adventure.node": "Điểm",
  "adventure.nodeType.start": "Trại",
  "adventure.nodeType.combat": "Chiến đấu",
  "adventure.nodeType.shop": "Cửa hàng",
  "adventure.nodeType.reward": "Kho báu",
  "adventure.nodeType.story": "Câu chuyện",
  "adventure.preview.unknown": "Cuộc chạm trán không rõ.",
  "adventure.preview.combat": "Một trận chiến.",
  "adventure.preview.shop": "Một cửa hàng.",
  "adventure.preview.reward": "Một kho báu.",
  "adventure.preview.story": "Một sự kiện cốt truyện.",
  "adventure.chooseNodeTitle": "Chọn {name}?",
  "adventure.travelNodeTitle": "Di chuyển đến {name}?",
  "adventure.chooseUnknownTitle": "Chọn điểm chưa biết?",
  "adventure.travelUnknownTitle": "Di chuyển đến điểm chưa biết?",
  "adventure.pathHidden": "Con đường phía trước sẽ ẩn cho đến khi bạn đến nơi.",
  "adventure.partyMustConfirm": "Các thành viên nhóm phải xác nhận trước khi sự kiện bắt đầu.",
  "adventure.fillDeckBeforeTravel": "Hãy lấp đầy Bộ bài Phiêu lưu với 10 trang bị và 10 kỹ năng trước khi di chuyển.",
  "adventure.choose": "Chọn",
  "adventure.travel": "Di chuyển",
  "adventure.fillEverySlot": "Hãy lấp đầy mọi ô trong Bộ bài Phiêu lưu bằng các lá trong Túi đồ trước khi di chuyển. Mỗi bộ cần 10 lá, tối đa {max} bản của cùng một lá.",
  "adventure.waitingPartyConfirm": "Đang chờ nhóm xác nhận ({ready}/{total})",
  "adventure.confirmReady": "Xác nhận sẵn sàng",
  "adventure.effects": "Hiệu ứng",
  "adventure.activeEffects": "Hiệu ứng đang có",
  "adventure.noActiveEffects": "Không có hiệu ứng nào.",
  "adventure.inventoryCount": "Túi đồ {n}/{max}",
  "adventure.defaultDeckName": "Hành trang Người học việc",
  "adventure.deckCounts": "{name} · Aspect {aspect}/1 · Trang bị {equipment}/{min} · Kỹ năng {ability}/{min}",
  "adventure.deckEditHint": "Chạm vào một ô để xem, xóa hoặc thay bằng lá trong Túi đồ. Lấp đầy mọi ô với tối đa {max} bản mỗi lá để tiếp tục di chuyển.",
  "adventure.leave": "Bỏ lại",
  "adventure.take": "Lấy",
  "adventure.party": "Nhóm",
  "adventure.partyHint": "Mời những người chơi đang Trực tuyến trong menu Chế độ Phiêu lưu. Tối đa 4 người.",
  "adventure.partyLeader": "Trưởng nhóm: {name}",
  "adventure.leaderSuffix": " (Trưởng nhóm)",
  "adventure.invitedYou": "{name} đã mời bạn",
  "adventure.invite": "Mời",
  "adventure.noEligible": "Không có người chơi phù hợp nào đang trực tuyến.",
  "adventure.leaveParty": "Rời nhóm",
  "adventure.waitingParty": "Đang chờ nhóm…",
  "adventure.combatSummary": "Tổng kết trận chiến",
  "adventure.resultGold": "{result} · Vàng nhận được {gold}",
  "adventure.enemiesDefeated_other": "Đã hạ {defeated}/{count} kẻ địch",
  "adventure.rewards": "Phần thưởng",
  "adventure.rewardHint": "Chạm vào lá để xem · Bấm Lấy để chọn phần thưởng, hoặc Bỏ lại để bỏ qua",
  "adventure.continueWhenReady": "Tiếp tục khi sẵn sàng",
  "adventure.resolvingCombat": "Đang xử lý trận chiến...",
  "adventure.shop": "Cửa hàng",
  "adventure.shopHint": "Vàng {gold} · Chạm vào lá để xem",
  "adventure.buyGold": "Mua {price} Vàng",
  "adventure.leaveShopWhenReady": "Rời cửa hàng khi sẵn sàng",
  "adventure.leaveShop": "Rời cửa hàng",
  "adventure.treasure": "Kho báu",
  "adventure.treasureHint": "Vàng {gold} · Chạm vào lá để xem · Bấm Lấy để chọn phần thưởng, hoặc Bỏ lại để bỏ qua",
  "adventure.story": "Câu chuyện",
  "adventure.youGain": "Bạn nhận được: {effects}",
  "adventure.enteringCombat": "Đang vào trận…",
  "adventure.tabDeck": "Bộ bài Phiêu lưu",
  "adventure.tabInventory": "Túi đồ",
  "adventure.tabMap": "Bản đồ",
  "common.player": "Người chơi",
  "common.hoursMinutesShort": "{hours} giờ {minutes} phút",
  "common.minutesShort": "{minutes} phút",
  "social.report": "Báo cáo",
  "social.block": "Chặn",
  "customize.board": "Bàn chơi",
  "customize.nameColor": "Màu tên",
  "customize.lockedSuffix": " (Đã khóa)",
  "customize.unlockFor": "Mở khóa {name} với giá {cost}",
  "customize.confirmPurchase": "Chạm lần nữa để mua",
  "customize.boardName.flat": "Phẳng",
  "customize.boardName.elegant": "Thanh lịch",
  "customize.boardName.ice": "Băng",
  "customize.boardName.nature": "Thiên nhiên",
  "customize.boardName.volcanic": "Núi lửa",
  "customize.boardName.castle": "Lâu đài",
  "customize.boardName.factory": "Nhà máy",
  "customize.boardName.swamp": "Đầm lầy",
  "customize.colorName.garnet": "Ngọc hồng lựu",
  "customize.colorName.scarlet": "Đỏ tươi",
  "customize.colorName.amber": "Hổ phách",
  "customize.colorName.gold": "Vàng",
  "customize.colorName.verdant": "Xanh lá",
  "customize.colorName.forest": "Xanh rừng",
  "customize.colorName.abyss": "Vực thẳm",
  "customize.colorName.steel": "Thép",
  "customize.colorName.mist": "Sương mù",
  "customize.colorName.white": "Trắng",
  "customize.colorName.cyan": "Lục lam",
  "customize.colorName.azure": "Xanh thiên thanh",
  "customize.colorName.sand": "Cát",
  "customize.colorName.clay": "Đất sét",
  "customize.colorName.umber": "Nâu đất",
  "customize.colorName.plum": "Mận",
  "customize.colorName.rainbow_holo": "Holo cầu vồng",
  "customize.colorName.metallic_holo": "Holo kim loại",
  "customize.colorName.gilded_holo": "Holo mạ vàng",
  "marketplace.refreshesIn": "Làm mới sau {time}",
  "marketplace.cards": "Lá bài",
  "marketplace.foils": "Phiên bản Foil",
  "marketplace.sold": "Đã bán",
  "marketplace.buy": "Mua",
  "marketplace.confirmBuy": "Xác nhận mua",
  "marketplace.noCards": "Không có lá bài bị khóa nào để mua.",
  "marketplace.noFoils": "Không có phiên bản foil nào.",
  "marketplace.notEnough": "Không đủ tiền tệ.",
  "achievements.title": "Thành tựu",
  "achievements.close": "Đóng thành tựu",
  "achievements.ready": "{n} sẵn sàng",
  "achievements.completionReward": "Thưởng hoàn thành",
  "achievements.completionRewardCollected": "Đã nhận thưởng hoàn thành",
  "achievements.none": "Chưa có thành tựu nào.",
  "achievements.collected": "Đã nhận",
  "achievements.collect": "Nhận",
  "achievements.collectCompletionTitle": "Nhận thưởng hoàn thành",
  "achievements.collectAllFirst": "Hãy nhận tất cả thành tựu trong danh mục này trước.",
  "achievements.view": "Xem thành tựu",
  "achievements.dailies": "Nhiệm vụ hằng ngày",
  "achievements.dailiesHint": "Tiến độ nhiệm vụ hằng ngày được tính trong mọi trận Cổ điển",
  "achievements.emptySlot": "Ô trống",
  "achievements.untilNewDaily": "Còn {time} đến nhiệm vụ mới",
  "achievements.newDailyArriving": "Nhiệm vụ mới sắp đến...",
  "achievements.untilExpired": "Còn {time} trước khi hết hạn",
  "achievements.removeAgainAria": "Nhấn lần nữa để xóa nhiệm vụ: {label}",
  "achievements.removeAria": "Xóa nhiệm vụ: {label}",
  "achievements.removeAgain": "Nhấn lần nữa để xóa",
  "achievements.remove": "Xóa nhiệm vụ",
  "achievements.rerollAgainAria": "Nhấn lần nữa để đổi nhiệm vụ với giá {cost} tiền tệ: {label}",
  "achievements.rerollAria": "Đổi nhiệm vụ với giá {cost} tiền tệ: {label}",
  "achievements.rerollAgain": "Nhấn lần nữa để đổi",
  "achievements.reroll": "Đổi nhiệm vụ này (mỗi nhiệm vụ một lần)",
  "achievements.loadingDailies": "Đang tải nhiệm vụ hằng ngày...",
  "dailies.dealDamage": "Gây {target} sát thương {type}",
  "dailies.applyAilment": "Gây {target} {ailment}",
  "dailies.gainResource": "Nhận {target} {attribute}",
  "dailies.playEquipment": "Chơi {target} lá Trang bị",
  "dailies.playAbility": "Chơi {target} lá Kỹ năng",
  "dailies.playAttribute": "Chơi {target} lá {attribute}",
  "dailies.playKind": "Chơi {target} kỹ năng {kind}",
  "dailies.playTag": "Chơi {target} lá {tag}",
  "dailies.winWithAspect_other": "Thắng {count} trận với {name}",
  "dailies.expendDamage": "Tiêu hao trang bị {target} lần để gây sát thương",
  "dailies.expendEffect": "Tiêu hao trang bị {target} lần cho hiệu ứng không gây sát thương, không tạo tài nguyên",
  "dailies.activateAbility": "Kích hoạt kỹ năng chủ động {target} lần",
  "dailies.invokeCards": "Khẩn cầu {target} lá bài",
  "dailies.activateCard": "Kích hoạt {name} {target} lần",
  "dailies.ailment.burn": "Bỏng",
  "dailies.ailment.poison": "Độc",
  "dailies.ailment.bleed": "Chảy máu",
  "dailies.ailment.shock": "Sốc điện",
  "dailies.ailment.chill": "Lạnh cóng",
  "dailies.ailment.wither": "Héo mòn",
  "match.portrait.closeAria": "Đóng thông tin người chơi",
  "match.portrait.deck": "Bộ bài: {n}",
  "match.portrait.hand": "Bài trên tay: {n}",
  "match.portrait.discard": "Bài bỏ: {n}",
  "common.loading": "Đang tải…",
  "common.ok": "OK",
  "common.loadingAssets": "Đang tải tài nguyên {loaded}/{total}",
  "social.chatMuted": "Bạn đang bị tắt tiếng và không thể xem hoặc gửi tin nhắn trò chuyện.",
  "social.chatGuest":
    "Trò chuyện yêu cầu tài khoản đã đăng ký. Hãy tạo hoặc chuyển sang tài khoản trong Cài đặt, rồi quay lại đây.",
  "social.chatLocked":
    "Trò chuyện sẽ mở khi tài khoản của bạn được ít nhất 24 giờ, hoặc sau khi bạn hoàn thành {games} trận mà không đầu hàng. Tiến độ: {completed}/{games} trận đã hoàn thành.",
  "social.chatLockedRemaining":
    "Trò chuyện sẽ mở khi tài khoản của bạn được ít nhất 24 giờ, hoặc sau khi bạn hoàn thành {games} trận mà không đầu hàng. Tiến độ: {completed}/{games} trận đã hoàn thành (còn {remaining}).",
  "social.chatAgreeTerms":
    "Hãy đồng ý với điều khoản trò chuyện trong trò chơi để xem và gửi tin nhắn.",
  "social.players": "Người chơi",
  "social.playersOnline": "{online} / {total} trực tuyến",
  "social.showPlayers": "Hiện người chơi",
  "social.hidePlayers": "Ẩn người chơi",
  "social.noPlayers": "Không có người chơi.",
  "social.noMessages": "Chưa có tin nhắn.",
  "social.messagePlaceholder": "Tin nhắn",
  "social.reportTitle": "Báo cáo {name}",
  "social.reportPrompt":
    "Vấn đề là gì? Báo cáo được giữ kín và do ATN DEV xem xét.",
  "social.reportCategory": "Loại báo cáo",
  "social.reportCategoryName.harassment": "Quấy rối, bắt nạt hoặc đe dọa",
  "social.reportCategoryName.hate": "Ngôn từ thù ghét hoặc phân biệt đối xử",
  "social.reportCategoryName.inappropriate": "Nội dung tình dục hoặc không phù hợp",
  "social.reportCategoryName.spam": "Spam hoặc lừa đảo",
  "social.reportCategoryName.cheating": "Gian lận hoặc khai thác lỗi",
  "social.reportCategoryName.username": "Tên người dùng xúc phạm",
  "social.reportCategoryName.other": "Khác",
  "social.reportDetails": "Chi tiết (không bắt buộc)",
  "social.reportDetailsPlaceholder": "Mô tả ngắn gọn điều đã xảy ra.",
  "social.reportChatIncluded":
    "Các tin nhắn trò chuyện gần đây của người chơi này sẽ được đính kèm trong báo cáo của bạn.",
  "social.reportBlockHint":
    "Bạn cũng có thể chặn {name} để ẩn tin nhắn trò chuyện và biểu cảm của họ.",
  "social.sending": "Đang gửi…",
  "social.submitReport": "Gửi báo cáo",
  "social.optIn.title": "Trò chuyện trong trò chơi (tùy chọn)",
  "social.optIn.optional":
    "Trò chuyện trong trò chơi là tùy chọn. Khi đồng ý, bạn chọn tham gia xem và gửi các tin nhắn do người chơi tạo.",
  "social.optIn.notMonitored":
    "Tin nhắn do người chơi tạo và không đại diện cho ATN DEV. Trò chuyện không nhất thiết được kiểm duyệt trước khi hiển thị. Đừng cho rằng trò chuyện là riêng tư hoặc bảo mật.",
  "social.optIn.conduct":
    "Không dùng trò chuyện để đe dọa, quấy rối, thù ghét, lừa đảo, spam, hoạt động phi pháp hoặc hành vi bị cấm khác. ATN DEV có thể xem xét báo cáo và có thể cảnh cáo, hạn chế trò chuyện, tạm khóa hoặc cấm tài khoản.",
  "social.optIn.sensitive":
    "Không chia sẻ mật khẩu, thông tin tài chính hoặc thông tin cá nhân nhạy cảm khác trong trò chuyện.",
  "social.optIn.detailsBefore": "Chi tiết đầy đủ có trong ",
  "social.optIn.detailsAfter": ".",
  "social.optIn.agree": "Tôi đồng ý",
  "social.status.online": "Trực tuyến",
  "social.status.offline": "Ngoại tuyến",
  "social.status.recentlyOnline": "Vừa trực tuyến",
  "social.status.inCpuGame": "Đang đấu CPU",
  "social.status.inGame": "Đang trong trận",
  "social.status.spectating": "Đang xem trận",
  "social.status.inDraftQueue": "Đang chờ Draft",
  "social.status.inQueue": "Đang chờ ghép trận",
  "social.status.viewingQueue": "Đang xem hàng chờ",
  "social.status.deckEditing": "Đang chỉnh bộ bài",
  "social.status.viewingCollection": "Đang xem bộ sưu tập",
  "social.status.viewingLibrary": "Đang xem thư viện",
  "social.status.viewingAchievements": "Đang xem thành tựu",
  "social.status.viewingGlossary": "Đang xem thuật ngữ",
  "social.status.adjustingSettings": "Đang chỉnh cài đặt",
  "social.status.customizingBoard": "Đang tùy chỉnh bàn đấu",
  "social.status.inMarketplace": "Trong chợ",
  "social.status.inSocial": "Trong mục Cộng đồng",
  "social.status.viewingRanking": "Đang xem bảng xếp hạng",
  "social.status.inWorkshop": "Trong xưởng",
  "social.status.viewingCommunity": "Đang xem diễn đàn",
  "social.status.viewingSupport": "Đang xem hỗ trợ",
  "social.status.viewingTutorials": "Đang xem hướng dẫn",
  "social.status.viewingSummary": "Đang xem tổng kết",
  "social.status.drafting": "Đang Draft",
  "social.status.buildingDraftDeck": "Đang xây bộ bài Draft",
  "social.status.viewingDraftSummary": "Đang xem tổng kết Draft",
  "social.status.adventureMode": "Chế độ phiêu lưu",
  "social.status.adventureCombatSummary": "Tổng kết trận phiêu lưu",
  "social.status.inAdmin": "Trong trang quản trị",
  "social.status.watchingReplay": "Đang xem phát lại",
  "social.draftMode": "Chế độ Draft",
  "social.bestDraftRun":
    "Lượt tốt nhất Thắng {wins} / Thua {losses} / Hòa {draws} · {lives} mạng · {games} trận",
  "social.draftPool": "Kho bài Draft",
  "social.noDraftRun": "Chưa hoàn thành lượt Draft nào.",
  "social.spectateGame": "Xem trận đấu",
  "social.blockedNotice":
    "Bạn đã chặn người chơi này. Tin nhắn trò chuyện và biểu cảm của họ bị ẩn, và họ không thể thách đấu bạn.",
  "social.noDecks": "Không có bộ bài.",
  "social.deckEquipmentPower": "Trang bị · Uy lực {power}",
  "social.deckAbilitiesPower": "Kỹ năng · Uy lực {power}",
  "ranking.cpuWinRatio": "Tỉ lệ thắng CPU",
  "ranking.humanWinRatio": "Tỉ lệ thắng người chơi",
  "ranking.cpuRecord": "CPU Thắng/Thua/Hòa",
  "ranking.humanRecord": "Người chơi Thắng/Thua/Hòa",
  "ranking.prev": "Trước",
  "ranking.next": "Sau",
  "community.discordCopy": "Tham gia Discord của Random's Projects.",
  "community.joinDiscord": "Tham gia Discord",
  "support.contactTitle": "Liên hệ hỗ trợ hoặc báo lỗi",
  "support.contactCopy":
    "Liên hệ với chúng tôi qua email để được giúp đỡ hoặc báo cáo sự cố.",
  "support.privacyPolicy": "Chính sách quyền riêng tư",
  "support.privacyCopy":
    "Thông tin chúng tôi thu thập, ai nhận được, lưu giữ bao lâu và cách xóa tài khoản cùng dữ liệu của bạn.",
  "support.privacyTitle": "Quyền riêng tư và an toàn dữ liệu",
  "support.privacyHighlightCollect":
    "Chúng tôi thu thập tên người dùng, mật khẩu đã băm, tiến trình chơi, địa chỉ IP và vị trí gần đúng. Không cần email, không có SDK phân tích hay quảng cáo.",
  "support.privacyHighlightShare":
    "Chúng tôi không bán dữ liệu cá nhân. Chỉ nhà cung cấp lưu trữ, định vị IP và email xử lý dữ liệu thay mặt chúng tôi.",
  "support.privacyHighlightChat":
    "Trò chuyện là tùy chọn, chỉ hiển thị với người chơi đã bật trò chuyện và bị xóa chậm nhất sau 90 ngày.",
  "support.privacyHighlightDelete":
    "Xóa tài khoản bất cứ lúc nào trong Cài đặt > Tài khoản, trên web hoặc qua email.",
  "support.privacyRead": "Đọc Chính sách quyền riêng tư",
  "support.privacyOpenWeb": "Mở phiên bản web",
  "support.privacyDeletePage": "Trang xóa tài khoản",
  "support.privacyPublicNote":
    "Cả hai trang đều công khai tại aeternainvicta.com/privacy và aeternainvicta.com/delete-account, không cần ứng dụng. Yêu cầu về quyền riêng tư: {email}.",
  "support.monetization": "Thông tin kiếm tiền",
  "support.monetizationCopy":
    "Cách trò chơi được phát triển, quảng cáo và Tiền tệ được cung cấp, và cam kết không trả tiền để thắng của chúng tôi.",
  "support.designPhilosophy": "Triết lý thiết kế",
  "support.designPhilosophyCopy":
    "Một lá thư ngắn từ nhà thiết kế về ý tưởng đằng sau trò chơi.",
  "support.designPhilosophyButton":
    "Tìm hiểu thêm về ý tưởng đằng sau Aeterna Invicta",
  "support.credits": "Ghi công và lời cảm ơn",
  "support.creditsCopy":
    "Bạn bè, người chơi thử và nhà phát hành đã giúp biến điều này thành hiện thực.",
  "support.entryTitle.about": "Giới thiệu Aeterna Invicta",
  "support.entryTitle.ageRating": "Phân loại độ tuổi và cảnh báo nội dung",
  "support.entryTitle.community": "Nguyên tắc cộng đồng và an toàn",
  "support.entryTitle.terms": "Điều khoản sử dụng",
  "support.entryTitle.accountData": "Tài khoản và xóa dữ liệu",
  "support.entrySummary.about":
    "Trò chơi là gì, cách chơi và ai tạo ra nó.",
  "support.entrySummary.ageRating":
    "Dành cho người chơi từ 13 tuổi trở lên. Có bạo lực giả tưởng và hình ảnh máu.",
  "support.entrySummary.community":
    "Cách giữ an toàn, những điều bị cấm và cách báo cáo sự cố.",
  "support.entrySummary.terms":
    "Quy định sử dụng trò chơi, tài khoản và vật phẩm trong trò chơi.",
  "support.entrySummary.accountData":
    "Chơi với tư cách khách, tài khoản đã đăng ký và cách xóa tài khoản cùng dữ liệu.",
  "support.contact.type": "Loại",
  "support.contact.bug": "Báo lỗi",
  "support.contact.email": "Email (để nhận phản hồi)",
  "support.contact.bugPrompt":
    "Vui lòng mô tả bạn đang làm gì và điều gì đã xảy ra khi lỗi xuất hiện.",
  "support.contact.helpPrompt": "Chúng tôi có thể giúp gì cho bạn?",
  "support.contact.send": "Gửi",
  "support.contact.sentTitle": "Đã gửi tin nhắn",
  "support.contact.enterEmail": "Nhập địa chỉ email hợp lệ.",
  "support.contact.enterMessage": "Nhập tin nhắn.",
  "support.contact.sendFailed": "Không thể gửi. Hãy thử lại.",
  "support.contact.confirmation":
    "Để hoàn tất liên hệ, hãy gửi email đã chuẩn bị tới {email} từ nhà cung cấp dịch vụ email của bạn.",
  "lore.readMore": "Đọc thêm",
  "rulebook.title": "Sách luật Aeterna Invicta",
  "rulebook.contents": "Mục lục",
  "rulebook.tableOfContents": "Mục lục",
  "support.privacyLoadFailed": "Không thể tải Chính sách quyền riêng tư.",
  "social.reportSubmitted":
    "Đã gửi báo cáo. Cảm ơn bạn đã giúp giữ Aeterna Invicta an toàn.",
  "social.reportFailed": "Không thể gửi báo cáo.",
  "social.playerFallback": "người chơi",
  "social.partyInviteSent": "Đã gửi lời mời vào nhóm tới {name}.",
  "social.challengeSent": "Đã gửi lời thách đấu tới {name}.",
  "social.challengeDeclined": "Đã từ chối thách đấu.",
  "social.challengeDeclinedBy": "{name} đã từ chối lời thách đấu của bạn.",
  "account.createdSignInRequired": "Đã tạo tài khoản, nhưng cần đăng nhập.",
  "account.createdPlayingAs": "Đã tạo tài khoản. Đang chơi với tên {name}.",
  "library.collection": "Bộ sưu tập",
  "library.rulebook": "Sách luật",
  "library.glossary": "Thuật ngữ",
  "library.lore": "Truyền thuyết",
  "library.intro":
    "Xem bộ sưu tập và các bộ bài mẫu, tra cứu từ khóa và cơ chế, hoặc đọc truyền thuyết của vương quốc.",
  "library.decksIntro":
    "Các bộ bài mẫu để tham khảo, hoặc xuất ra để sử dụng nếu bạn đã mở khóa các lá bài.",
  "library.missingCards": "Thiếu lá bài trong bộ sưu tập của bạn",
  "library.noDecks": "Không có bộ bài thư viện nào.",
  "library.resetDecks": "Đặt lại bộ bài",
  "library.resetDecksTitle": "Đặt lại bộ bài?",
  "library.resetDecksBody":
    "Thao tác này thay thế tất cả bộ bài đã lưu của bạn bằng các bộ bài Thư viện mà bạn sở hữu đủ mọi lá. Bộ bài tùy chỉnh và các chỉnh sửa sẽ bị mất.",
  "library.export": "Xuất",
  "library.deckAbilityPower": "Kỹ năng · Uy lực {power}",
  "glossary.backToSearch": "Quay lại tìm kiếm",
  "glossary.relatedCards": "Lá bài liên quan ({n})",
  "glossary.noRelatedCards": "Không tìm thấy lá bài liên quan.",
  "glossary.search": "Tìm kiếm",
  "glossary.searchPlaceholder": "Từ khóa, thuật ngữ, cơ chế",
  "glossary.noMatches": "Không có thuật ngữ phù hợp.",
  "patchNotes.title": "Ghi chú cập nhật",
  "workshop.showControls": "Hiện điều khiển",
  "workshop.hideControls": "Ẩn điều khiển",
  "workshop.addCard": "Thêm lá bài",
  "workshop.yourTurn": "Lượt của bạn",
  "workshop.opponentTurn": "Lượt đối thủ",
  "workshop.reset": "Đặt lại",
  "workshop.hp": "HP {hp}/{maxHp}",
  "workshop.switchAspectFor": "Đổi Aspect cho {name}",
  "workshop.addCardTo": "Thêm lá bài cho {name}",
  "workshop.chooseAspect": "Chọn một Aspect cho vị trí này.",
  "workshop.maxCopiesPerSide": "Tối đa {max} bản của cùng một lá bài mỗi bên.",
  "gamepad.connected": "Đã kết nối tay cầm",
  "gamepad.statusTitle": "{pad} · Nút Select chuyển thanh điều hướng/màn hình",
  "gamepad.ariaNav": "Đã kết nối tay cầm, đang chọn thanh điều hướng",
  "gamepad.ariaView": "Đã kết nối tay cầm, đang chọn màn hình",
  "gamepad.padNav": "Tay cầm · Điều hướng",
  "gamepad.padView": "Tay cầm · Màn hình",
  "gamepad.connectedToast": "Đã kết nối tay cầm: {label}",
  "card.statusEffect": "Hiệu ứng trạng thái",
  "card.empoweredPhysicalArmor": "Cường hóa: Giáp Vật Lý +{amount} (Đặc Tính, khi trang bị)",
  "card.empoweredMagicArmor": "Cường hóa: Giáp Phép +{amount} (Đặc Tính, khi trang bị)",
  "card.levels": "Cấp độ",
  "card.level": "Cấp",
  "card.cost": "Chi phí",
  "card.tapToReturn": "Chạm để trả lá bài",
  "card.powerN": "Uy lực {power}",
  "card.locked": "Đã khóa",
  "match.board.needResource": "Cần {need} {attribute} (bạn có {have})",
  "match.board.needHealth": "Cần {need} máu (bạn có {have})",
};

export default vi;
